import LazyLoad from "react-lazyload";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import Header from "../Component/Header";
import Menu from "../Component/Menu";
import PageTitle from "../Component/PageTitle";
const Music = () => {
  const homeMenu = [
    {
      label: "Curriculum",
      link: "",
      subMenu: [
        { label: "Primary Wing", link: "/primarywing" },
        { label: "Middle Wing", link: "/middleWing" },
        { label: "Senior Wing", link: "/seniorWing" },
        { label: "Curriculum", link: "/curriculum" },
      ],
    },

    {
      label: "Extended Classroom",
      link: "",
      subMenu: [
        { label: "Labs", link: "/mathmatics" },
        { label: "Excursions", link: "/excursions" },
        { label: "Library", link: "/library" },
        { label: "Field Trips", link: "/feildTrip" },
        { label: "Astronomy", link: "/astronomy" },
      ],
    },
    {
      label: "Sports",
      link: "",
      subMenu: [
        { label: "Sports", link: "/sports" },
        {
          label: "Achievements in Sports 2022-23",
          link: "/acheivementInSports",
        },
      ],
    },
    {
      label: "Arts",
      link: "",
      subMenu: [
        { label: "Performing Arts", link: "/music" },
        { label: "Visual Arts", link: "/visualArts" },
      ],
    },

    { label: "Houses", link: "/houses" },
    { label: "Assembly", link: "/assembly" },
    { label: "Book List", link: "/booklist" },
  ];
  return (
    <>
      <Header />
      <Breadcrumb breadImage="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/banner-music.jpg" />
      <Menu MenuItem={homeMenu} />
      <div className="padding-blk inner-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-12">
              <PageTitle
                pageTitle="Facilities"
                breadEnd="Learning Approach"
                breadMid="Music"
              />
            </div>
          </div>
          <div className="row ">
            <div className="col-xl-12 mb-4">
              <h4 className="color-red">Music</h4>
              <div class="lab-heading mb-4">
                <div class="lab-btn" id="mb-lab-btn">
                  <span>PERFORMING ARTS</span>
                </div>
                <ul class="labs-list">
                  <li>
                    <a class="inc-tlink-active" href="/music">
                      Music
                    </a>
                  </li>
                  <li>
                    <a class="" href="/dance">
                      Dance
                    </a>
                  </li>
                </ul>
              </div>
              <h5 className="color-green mb-4">Western Music </h5>
              <LazyLoad>
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/western1.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                To foster love and appreciation of music and nurture the
                artistic qualities of our learners, the school provides training
                to the budding artists through Western Music. Learners are
                taught all essential aspects of performance training including
                sitting posture, music reading, improvising and repertoire
                building from beginner to advanced levels. Basic Music theory is
                taught to all students to help build a strong musical
                foundation. Learners are encouraged to play all instruments to
                enable them to make a final choice of instrument they would want
                to learn. Learners can choose from a wide variety of instruments
                including keyboard, guitar, drums etc. On guitar and keyboard,
                learners are taught fingering scale exercises, chords, chord
                progressions and playing songs ,whereas on drums they are taught
                from the counting exercise to the holding of drumsticks, open
                hand exercise, playing beats on counts etc.
              </p>
            </div>
            <div className="col-md-12">
              <h5 className="color-green mb-4">Indian Vocal Music </h5>
              <LazyLoad>
                {" "}
                <img
                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/indian.jpg"
                  className="float-end wid-500 m-2"
                  alt="Lotus Valley Gurgaon"
                />
              </LazyLoad>
              <p>
                The school provides Indian Music training in both Instrumental
                and Vocal segments under the able guidance of qualified and
                experienced faculty. Learners are groomed for voice culture to
                accentuate the right musical note; they are taught different
                ragas and compositions of rhythm patterns. Besides light music,
                learners are taught Sarv Dharma prayers and theme based songs.
                Learners are aesthetically trained on various Indian musical
                instruments accompanied by singing and descanting. Tabla lessons
                are well planned to familiarize learners with ‘Indian rhythm
                structure’ and 'countings.'
              </p>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};
export default Music;
